import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, InputGroup, FormControl, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const CLIENT_ID = "bf33d54cf140414babdbbc0ae32a699d";
const CLIENT_SECRET = "b3494517ba63432d8692a9e48d90404c";

// This web app might not work with only Live Server, because I have created the app in React. 
// This way my JavaScript and JQuery code still fit all the criteria perfectly, but the code is easier to manage.

// If Live Server does not work, please open a new terminal. 
// In the terminal, ...\SpotifySearcher\client has to be open. 
// If ...\SpotifySearcher is open, type 'cd client' and hit enter to open ...\SpotifySearcher\client. 
// Now type 'npm start' and the web app will open automatically in the browser. 

function App() {
  const [searchInput, setSearchInput] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [selectedButton, setSelectedButton] = useState("");

  useEffect(() => {
    // Controleer of jQuery beschikbaar is
    if (!window.$) {
      console.error("jQuery is not loaded. Make sure jquery-3.4.1.min.js is properly placed in the public folder..");
      return;
    }

    // Gebruik jQuery om toegangstoken op te halen
    window.$.ajax({
      url: 'https://accounts.spotify.com/api/token',
      type: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: {
        grant_type: 'client_credentials',
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
      },
      success: function (data) {
        setAccessToken(data.access_token);
      },
      error: function (error) {
        console.error('Error retrieving access token:', error);
      },
    });
  }, []);

  function resetButtons() {
    setSelectedButton(""); // Reset de geselecteerde knop
  }

  function search(query = searchInput) {
    if (!query) {
      // Als er geen zoekterm is ingevoerd
      window.$("#albums-container").html('<p class="text-center text-danger">Enter an artist name!</p>');
      return;
    }

    console.log("Search for " + query); // Debug output
    setSearchInput(""); // Wis het invoerveld
    window.$("#albums-container").empty(); // Verwijder eerder weergegeven albums

    // Zoek de artiest-ID op
    window.$.ajax({
      url: `https://api.spotify.com/v1/search?q=${query}&type=artist`,
      type: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      success: function (data) {
        if (data.artists.items.length === 0) {
          // Geen artiest gevonden
          window.$("#albums-container").html('<p class="text-center text-warning">No artist found.</p>');
          return;
        }

        const artistID = data.artists.items[0].id;
        console.log("Artist ID is " + artistID);

        // Haal albums van de artiest op
        window.$.ajax({
          url: `https://api.spotify.com/v1/artists/${artistID}/albums?include_groups,single=album&market=NL&limit=50`,
          type: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          success: function (data) {
            if (data.items.length === 0) {
              // Geen albums gevonden
              window.$("#albums-container").html('<p class="text-center text-warning">No albums found.</p>');
            } else {
              data.items.forEach((album) => {
                const albumHTML = `
                  <div class="card">
                    <img class="card-img-top" src="${album.images[0]?.url}" alt="Album cover">
                    <div class="card-body">
                      <h3 class="card-title">${album.name}</h3>
                      <p class="card-text">Released on ${album.release_date}</p>
                      <p class="card-text">${album.total_tracks} tracks</p>
                      <a href="https://open.spotify.com/album/${album.id}" target="_blank" class="btn btn-primary">
                        Listen here
                      </a>
                    </div>
                  </div>
                `;
                window.$("#albums-container").append(albumHTML);
              });
            }
          },
          error: function (error) {
            console.error("Error retrieving albums:", error);
            window.$("#albums-container").html('<p class="text-center text-danger">Error retrieving albums. Please try again.</p>');
          },
        });
      },
      error: function (error) {
        console.error("Error retrieving artist:", error);
        window.$("#albums-container").html('<p class="text-center text-danger">Error retrieving artist. Please try again.</p>');
      },
    });
  }

  function handleButtonClick(buttonValue) {
    setSelectedButton(buttonValue); // Zet de huidige knop als geselecteerd
    resetButtons();
    search(buttonValue); // Voer de zoekopdracht uit
  }

  return (
    <div className="App">
      <Container>
        <InputGroup className="mb-3" size="lg">
          <FormControl
            placeholder="Find an artist"
            type="input"
            value={searchInput}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                resetButtons();
                search();
              }
            }}
            onChange={(event) => setSearchInput(event.target.value)}
          />
          <Button
            onClick={() => {
              resetButtons();
              search();
            }}
          >
            Search
          </Button>
        </InputGroup>
        <div className="d-flex gap-2">
          {["Luke on the hill", "Laufey", "Forrest Frank", "Josh Garrels"].map((artist) => (
            <Button
              key={artist}
              onClick={() => handleButtonClick(artist)}
              className={selectedButton === artist ? "btn-primary" : "btn-outline-primary"}
            >
              {artist}
            </Button>
          ))}
        </div>
      </Container>
      <Container>
        <div id="albums-container" className="row mx-2 row-cols-3"></div>
      </Container>
    </div>
  );
}

export default App;
